import { BitrixVue } from 'ui.vue';
import '../modals/interiorModal.js';
import { Fancybox } from '@fancyapps/ui';

BitrixVue.component('ConfigLeft', {
	data() {
		return {
			fancyInstance: null,
			previewImage: null,
		};
	},
	props: ['totalAmount', 'positionPrice', 'storePosition', 'triggerIncrease', 'previewDoor', 'basketChange', 'imageLoading'],
	methods: {
		showInterier() {
			this.$emit('showInterier', 'interiorModal');
		},
		closeModal(modal) {
			if (isShow) this.$refs[modal].close();
		},
		increaseImage() {
			const image = this.$refs['FancyImage'].src;
			this.fancyInstance = new Fancybox(
				[
					{
						src: image,
						type: 'image',
					},
				],
				{
					on: {
						destroy: (fancybox, slide) => {
							this.$emit('destroyFancy');
						},
					},
				}
			);
		},
	},
	watch: {
		storePosition(val) {
		},
		triggerIncrease(val) {
			if (val) {
				this.increaseImage();
			}
		},
		previewImage(val) {
			if (val !== null) {
				this.$emit('previewForInterier', this.previewImage);
			}
		},
	},
	template: `
    <div class="config-left__wrapper">
        <div class="config-left__interior" @click="showInterier">
		    <ui-tooltip position="right" animation="fade">Смотреть в интерьере</ui-tooltip>
        </div>
        <div class="config-left__img">
            <img v-if="storePosition.renderImage" :src="storePosition.renderImage" alt="" ref="FancyImage">
            <img v-else :src="storePosition.previewImage" alt="" ref="FancyImage">
						<div v-if='imageLoading' class="config-image__loading">
							<div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
						</div>
        </div>
        <div class="config-left__info">
            <div class="config-left__price-door">
                Стоимость двери: <span>{{new Intl.NumberFormat('ru-RU', { style: 'currency', currency: 'RUB' }).format(positionPrice)}}</span>
            </div>
            <div class="config-left__price-total">
                Стоимость всех дверей:
                <span>{{new Intl.NumberFormat('ru-RU', { style: 'currency', currency: 'RUB' }).format(totalAmount)}}</span>
            </div>
        </div>
        <div class="config-left__img-increase" @click="increaseImage()"></div>
        <ConfigBlockCanvas :canvasData="storePosition" :previewDoor="previewDoor" :basketChange="basketChange" v-on:previewImageChange="previewImage = $event.previewImage" :clearRenderImageCache="this.$store.state.clearRenderImageCache" />
    </div>
`,
});
